export const UNIT_TRUST_INVESTMENT_ACCOUNT = 'UT_HBSP';
export const EQUITY_INVESTMENT_ACCOUNT = 'SEC_HBSP';
export const STRUCTURED_PRODUCTS_ACCOUNT = 'SP_HBSP';
export const BONDS_ACCOUNT = 'BOND_HBSP';
export const HSBC_CONVENTIONAL_UT_ACCOUNT = 'UT_HBMB';
export const HSBC_AMANAH_UT_ACCOUNT = 'UT_HBMS';
